// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import Collapsible from './../../components/Collapsible/Collapsible';

import Styles from './faqItem.module.scss';
import { useTranslation } from 'react-i18next';
import { logPageAction } from 'src/lib/ApplicationInsights';

interface FaqItem {
    isOpen: boolean;
    items?: any[];
    key: any;
    name: string;
}

interface FaqItemPropType {
    faq: FaqItem;
}


function FaqCategoryHeader(text: string): JSX.Element {

    return (
        <div className={Styles.faqHeaderText}>
            <div className={Styles.faqHeaderText}>
                {text}
            </div>
        </div>
    );
}

const FaqItem = (props: FaqItemPropType) => {
    const { isOpen, items, name } = props.faq;
    const [expandedItems, setExpandedItems] = React.useState({});
    const { t } = useTranslation('faqTranslation');
    const onToggle = (item: any) => (event: any) => {
        logPageAction('FAQ item selected', { itemSelected: item.name });

        // Retain nested item's toggled/expanded status as a stateful value
        const updatedExpandedItems = { ...expandedItems };
        updatedExpandedItems[item.key] = !updatedExpandedItems[item.key];
        setExpandedItems(updatedExpandedItems);
    };
    const renderItems = (item: any) => {
        return (
            <div>
                {
                    item && item.solutionItems.map((solution: any, ind: number) => {
                        return (
                            <div key={ind}>
                                {
                                    solution.leadingParagraph ? <div className={Styles.itemDetail}>{ReactHtmlParser(t(solution.leadingParagraph))}</div> : null
                                }

                                {
                                    solution && Array.isArray(solution.bulletPoints) && solution.bulletPoints.length
                                        ? (
                                            <ul>
                                                {
                                                    solution && solution.bulletPoints.map((sol: any, i: number) => {
                                                        return (
                                                            <li key={i} className={Styles.item}>
                                                                {ReactHtmlParser(t(sol.ans))}
                                                            </li>
                                                        );
                                                    })

                                                }
                                            </ul>
                                        ) : null
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    };
    return (

        <div className={Styles.faqItem}>
            <Collapsible
                isOpen={isOpen}
                colorOnOpen={'white'}
                colorOnClose={'nobel'}
                chevronColor={'black'}
                header={FaqCategoryHeader(t(name))}
                tableName={t(name)}
            >
                <div className={Styles.faqItem}>
                    {
                        Array.isArray(items) && items.map((item: any) => {
                            return (
                                <div key={item.key} className={Styles.items}>
                                    <button aria-label={t(expandedItems[item.key] ? 'button_expanded_message' : 'button_collapsed_message',{ tableName: t(item.name) })}
                                        className={clsx(Styles.collapsible, expandedItems[item.key] ? Styles.active : '')}
                                        onClick={onToggle(item)}
                                        tabIndex={0}
                                    >
                                        {t(item.name)}
                                    </button>

                                    {
                                        expandedItems[item.key]
                                            ? (
                                                renderItems(item)
                                            ) : null
                                    }
                                </div>
                            );
                        })
                    }
                </div>
            </Collapsible>
        </div>
    );
};

export default FaqItem;
